import withApi from "./utils/apiPathFactory";

export default withApi({
  version: 1,
  routes: {
    oauth: {
      slack: {
        individual: {
          base: "/oauth/slack/individual",
          url: "/oauth/slack/individual/url",
        },
      },
      google: {
        auth: {
          callback: "/oauth/google/auth/callback",
        },
      },
    },
    webhooks: {
      notify: "/webhooks/notify/:webhookId",
    },
  },
});
